import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class DailyPlanningCacheService {
  private static readonly PREFIX = 'DailyPlanningOverview';

  public getSelectedDate(): moment.Moment {
    let toReturn = localStorage.getItem(
      DailyPlanningCacheService.PREFIX + '-date'
    );
    return toReturn == null
      ? null
      : moment(toReturn, moment.defaultFormat)
          .tz('Europe/Brussels')
          .locale('nl-BE');
  }

  public setSelectedDate(input: moment.Moment): void {
    localStorage.setItem(
      DailyPlanningCacheService.PREFIX + '-date',
      input.startOf('day').format(moment.defaultFormat)
    );
  }

  public getSelectedEmployeeId(): number {
    let toReturn = localStorage.getItem(
      DailyPlanningCacheService.PREFIX + '-employee'
    );
    return toReturn == null ? null : Number.parseInt(toReturn);
  }

  public setSelectedEmployeeId(id: number): void {
    localStorage.setItem(
      DailyPlanningCacheService.PREFIX + '-employee',
      id.toString()
    );
  }
}
